const copyID = () => {
  let productReassurancesCopyid = document.querySelector('.product-reassurances-copyid');
  if (productReassurancesCopyid) {
    productReassurancesCopyid.addEventListener('click', (e) => {
      let productMfc;
      if(e.target.classList.contains('product-reassurances-copyid')) {
        productMfc = e.target.querySelector('#product-mfc');
      } else {
        productMfc = e.target.closest('.product-reassurances-copyid').querySelector('#product-mfc');
      }

      // show and hide popover
      let popover = document.querySelector(".copy-popover");
      function hidePopover(e) {
        const isClosest = e.target.closest('.product-reassurances-copyid');
        if (!isClosest && popover.classList.contains('show')) {
          popover.classList.remove('show');
          window.removeEventListener("click", hidePopover);
        }
      }

      if (productReassurancesCopyid.contains(popover)) {
        navigator.clipboard.writeText(productMfc.innerText);
        popover.classList.add('show');
        window.addEventListener("click", hidePopover);
      } else {
        navigator.clipboard.writeText(productMfc.innerText).then(() =>  {
  
        // show notification
        const event = new CustomEvent('notification:show', {
          detail: { 
            message: productMfc.getAttribute('data-message'),
            icon: true,
            link: false,
            linkCart: false,
            linkWishlist: false
          }
        });
        document.body.dispatchEvent(event);
        
      },(err) =>  {
        console.error(err);
      });
      }
    }); 
  }
}
module.exports = {
  copyID: copyID
}